import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/novaLogoMain.png";
import { IoClose } from "react-icons/io5";
import { useUser } from "../../context/UserContext";
import React, { useEffect, useRef, useState } from "react";
import NotificationsDropdown from "../notificationsDropdown/NotificationsDropdown";
import CategoriesModal from "./CategoriesModal";
import { endpoints } from "../../../api/endpoints";
import { getFetcher } from "../../../api/fetchers";
import { RxHamburgerMenu } from "react-icons/rx";
import Mobile from "./Mobile";
import { FaRegHeart } from "react-icons/fa";
import { FiShoppingCart } from "react-icons/fi";
import { toast } from "react-toastify";
import { parseStatics } from "../../function/parseStatics";
import { useLanguage } from "../../context/LanguageContext";
import { Tooltip } from "flowbite-react";
import { FaRegUser } from "react-icons/fa6";
import LoginPopUp from "../../pages/login/LoginPopUp";

interface Category {
  id: number;
  name: string;
  image: string;
  status: boolean;
  createdAt: string;
  updatedAt: string;
  subCategories?: SubCategory[];
}

interface SubCategory {
  id: number;
  name: string;
  mainCategoryId: number;
  status: boolean;
  createdAt: string;
  updatedAt: string;
  image: string;
}

const Navbar: React.FC = () => {
  const { t } = useLanguage();
  const [categoriesData, setCategoriesData] = useState<Category[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(
    null
  );
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMobil, setIsMobil] = useState<boolean>(false);
  const [showMobile, setShowMobile] = useState<boolean>(false);
  // user
  const { user, isAuth, getIsAuth, trueShowLoginPopup, showLoginPopup } =
    useUser();

  // states
  const [categoryModal, setCategoryModal] = useState<boolean>(false);
  const modalRef = useRef<any>(null);
  const categoriesRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const [basketCount, setBasketCount] = useState<number>(0);

  useEffect(() => {
    const checkScreenWidth = () => {
      setIsMobil(window.innerWidth < 1024);
    };
    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);

    return () => {
      window.removeEventListener("resize", checkScreenWidth);
    };
  }, []);

  useEffect(() => {
    const isAuthanticate = async () => {
      await getIsAuth();
    };

    isAuthanticate();
  }, []);

  const handleClickCategory = (category: Category) => {
    if (selectedCategory?.id === category.id) {
      setIsAnimating(false);
      setTimeout(() => setCategoryModal(false), 300);
      setSelectedCategory(null);
    } else {
      setSelectedCategory(category);
      if (!categoryModal) {
        setCategoryModal(true);
        setTimeout(() => setIsAnimating(true), 50);
      }
    }
  };

  const closeModal = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setCategoryModal(false);
      setSelectedCategory(null);
    }, 600);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      modalRef.current &&
      !modalRef.current.contains(event.target as Node) &&
      categoriesRef.current &&
      !categoriesRef.current.contains(event.target as Node)
    ) {
      closeModal();
    }
  };

  useEffect(() => {
    if (categoryModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [categoryModal]);

  let localUserId: any;
  useEffect(() => {
    // @ts-ignore
    localUserId = parseStatics(localStorage.getItem("defaultUserId"));
  }, []);

  useEffect(() => {
    const getBasketData = async () => {
      try {
        if (user) {
          const response = await getFetcher(endpoints.user.getUserBasket);
          if (response?.result) {
            if (isAuth) {
              setBasketCount(response?.basketItems?.length);
            } else {
              setBasketCount(0);
            }
          }
        } else if (localUserId) {
          const response = await getFetcher(
            endpoints.user.getLocalBasket.replace(
              "{userId}",
              localUserId ? localUserId : ""
            )
          );
          if (response?.result) {
            setBasketCount(response?.basketItems?.length);
          } else {
            setBasketCount(0);
          }
        } else {
          setBasketCount(0);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getBasketData();
  }, [isAuth, user, localUserId]);

  const renderMainCategories = () => (
    <div
      ref={categoriesRef}
      className="flex justify-between w-full xl:w-[100%] mx-auto items-center -ml-1"
    >
      {categoriesData.map((category) => (
        <div
          key={category.id}
          className={`flex items-center${
            selectedCategory?.id === category.id ? "scale-105" : ""
          } transition-transform duration-300`}
          onClick={() => handleClickCategory(category)}
        >
          <p
            className={`font-light md:font-bold font-poppins md:text-[10px]  lg:text-[12px] xl:text-[13px] 2xl:text-[15px] px-1 xl:px-2 2xl:px-4 py-1 text-center cursor-pointer hover:text-yellow-color transform duration-300 ${
              selectedCategory?.id === category.id
                ? "text-[#FFC633]"
                : "text-[#777497]"
            }`}
          >
            {category.name.toLocaleUpperCase()}
          </p>
        </div>
      ))}
    </div>
  );

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getFetcher(
          endpoints.products.getProductCategory
        );
        if (response.result) {
          const categoriesWithSubCategories = await Promise.all(
            response.productCategories.map(async (category: Category) => {
              const subCategoriesResponse = await getFetcher(
                endpoints.products.getProductSubCategoriesByCategoryId.replace(
                  "{id}",
                  category.id.toString()
                )
              );
              return {
                ...category,
                subCategories: subCategoriesResponse.result
                  ? subCategoriesResponse.productSubCategories
                  : [],
              };
            })
          );
          setCategoriesData(categoriesWithSubCategories);
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className={`bg-[#FFFFFF] px-2  md:px-4 2xl:px-8 py-4 relative z-40`}>
      <div className="flex items-center justify-between w-full overflow-hidden">
        <div className="flex items-center justify-between flex-shrink-0">
          {isMobil && (
            <div className=" block lg:hidden mb-1 mr-1">
              <RxHamburgerMenu
                onClick={() => {
                  setShowMobile(!showMobile);
                }}
                className={`cursor-pointer min-w-[24px] transform transition-transform duration-300 ${
                  showMobile
                    ? "rotate-90 text-yellow-color"
                    : "rotate-0 text-black"
                }`}
                size={24}
              />
            </div>
          )}
          {/* LOGO */}
          <div className="w-[170px] md:w-[240px] 2xl:w-[320px] h-auto min-w-[100px]">
            <Link to={"/"}>
              <img src={logo} alt="logo" />
            </Link>
          </div>
        </div>

        {/* LINKS - DESKTOP */}
        <div className="hidden lg:flex flex-grow justify-between gap-x-1 md:gap-x-3 lg:gap-x-4 w-full  truncate overflow-hidden">
          {renderMainCategories()}
        </div>

        {/* Social Media & Kullanıcı Bilgisi */}
        <div className="flex items-center gap-x-1 md:gap-x-10 justify-end flex-shrink-0 mt-2 space-y-1">
          {/* Social Media Links */}
          <div className="flex gap-x-2 py-2  ">
            <div className="pr-1 sm:pr-2 h-8 flex items-center">
              {isAuth ? (
                <div
                  onClick={() => navigate("/basket")}
                  className=" relative flex flex-col items-center cursor-pointer mt-0 lg:mt-1"
                >
                  <FiShoppingCart className=" text-yellow-color cursor-pointer hover:scale-110 transition-transform duration-300 transform text-xl" />
                  <p className=" text-yellow-color font-montserrat font-semibold text-[11px]  hidden md:block ">
                    {t("navbar", "carts")}
                  </p>
                  <span className=" absolute -top-3 -right-2 text-[11px] font-semibold pt-[1px] pl-[1px] border rounded-full w-5 h-5 flex justify-center items-center bg-primary-color text-white">
                    {basketCount}
                  </span>
                </div>
              ) : (
                <div
                  onClick={() => toast.warning(t("toastMessage", "loginInfo"))}
                  className=" relative flex flex-col items-center cursor-pointer"
                >
                  <FaRegHeart className=" text-yellow-color cursor-pointer hover:scale-90 transition-transform duration-300 transform text-xl" />
                  <p className=" text-yellow-color font-montserrat font-semibold text-[11px] hidden md:block">
                    {t("navbar", "favorites")}
                  </p>
                </div>
              )}
            </div>
            <div className=" pr-1 sm:pr-2 h-8 flex items-center lg:hidden">
              {!isAuth ? (
                <Tooltip content={t("navbar", "login")} style="light">
                  <div
                    onClick={() => {
                      if (isAuth == false) {
                        trueShowLoginPopup();
                      }
                    }}
                    className=" relative flex flex-col items-center cursor-pointer"
                  >
                    <FaRegUser className=" text-yellow-color cursor-pointer hover:scale-110 transition-transform duration-300 transform text-xl" />
                    <p className=" text-yellow-color font-montserrat font-semibold text-[11px] hidden md:block">
                      {t("navbar", "login")}
                    </p>
                  </div>
                </Tooltip>
              ) : (
                <div
                  onClick={() => navigate("/profile/favorites")}
                  className=" relative flex flex-col items-center cursor-pointer"
                >
                  <FaRegHeart className=" text-yellow-color cursor-pointer hover:scale-110 transition-transform duration-300 transform text-xl" />
                  <p className=" text-yellow-color font-montserrat font-semibold text-[11px] hidden md:block">
                    {t("navbar", "favorites")}
                  </p>
                </div>
              )}
            </div>

            {isAuth && (
              <div
                onClick={() => navigate("/profile/favorites")}
                className=" relative flex-col items-center cursor-pointer  lg:flex hidden"
              >
                <FaRegHeart className=" text-yellow-color cursor-pointer hover:scale-110 transition-transform duration-300 transform text-xl" />
                <p className=" text-yellow-color font-montserrat font-semibold text-[11px] hidden md:block">
                  {t("navbar", "favorites")}
                </p>
              </div>
            )}

            <div className="h-8 flex items-center mr-2 ">
              {isAuth ? (
                <>
                  <NotificationsDropdown />
                  <p className=" absolute bottom-6 text-yellow-color font-montserrat font-semibold text-[11px] hidden md:block">
                    {t("navbar", "notifications")}
                  </p>
                </>
              ) : (
                <div onClick={() => navigate("/basket")} className=" relative flex flex-col items-center cursor-pointer ">
                  <FiShoppingCart
                    size={24}
                    className=" text-yellow-color cursor-pointer hover:scale-110 transition-transform duration-300 transform"
                  />
                  <p className=" text-yellow-color font-montserrat font-semibold text-[11px] hidden md:block">
                    {t("navbar", "carts")}
                  </p>
                  <span className=" absolute -top-3 -right-2 text-[11px] font-semibold pt-[1px] pl-[1px] border rounded-full w-5 h-5 flex justify-center items-center bg-primary-color text-white">
                    {basketCount}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* User Info */}
          {isAuth && (
            <div
              className="flex items-center gap-x-1 flex-shrink-0 ml-6 cursor-pointer"
              onClick={() => navigate("/profile")}
            >
              <img
                className="w-10 h-10 rounded-full object-cover -mt-4"
                src={
                  user?.profilePicture
                    ? user?.profilePicture
                    : "https://static.vecteezy.com/system/resources/thumbnails/020/765/399/small/default-profile-account-unknown-icon-black-silhouette-free-vector.jpg"
                }
                alt="user"
              />
              <div className=" hidden sm:flex lg:hidden xl:flex flex-col sm:flex-row sm:items-center text-center sm:text-left text-xxs sm:text-xs gap-x-1 font-poppins -mt-3">
                <p className="font-light text-gray-800">
                  👋 {t("navbar", "say")},
                </p>
                <p className="font-semibold">
                  {user?.firstName ? user?.firstName : user?.name}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Categories Modal */}
      {categoryModal && (
        <div
          ref={modalRef}
          className={`absolute top-[80px] left-0 right-0 bg-white  transition-all duration-500 ease-in-out ${
            isAnimating
              ? "opacity-100 translate-y-0 scale-100"
              : "opacity-0 -translate-y-10 scale-95"
          }`}
        >
          <div className=" py-4 shadow-lg">
            <CategoriesModal
              categoriesData={selectedCategory}
              setCategoryModal={setCategoryModal}
              setSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}
            />
          </div>
        </div>
      )}

      {showMobile && (
        <div className=" relative">
          <Mobile
            categoriesData={categoriesData}
            setShowMobile={setShowMobile}
          />
          <div
            onClick={() => setShowMobile(false)}
            className=" absolute -top-6 right-0 cursor-pointer text-black"
          >
            <IoClose size={22} />
          </div>
        </div>
      )}

      {showLoginPopup && (
        <div className="z-50">
          <LoginPopUp />
        </div>
      )}
    </div>
  );
};

export default Navbar;
